import { useEffect, useRef } from "react";
import confetti from "canvas-confetti";

/**
 * Fires a celebratory confetti burst once when `shouldFire` becomes true.
 * Safe to call on every render — only fires on the first truthy transition.
 */
export function useConfetti(shouldFire: boolean): void {
  const hasFired = useRef(false);

  useEffect(() => {
    if (!shouldFire || hasFired.current) return;
    hasFired.current = true;

    const end = Date.now() + 2_000;
    let rafId: number | undefined;

    const frame = () => {
      confetti({
        particleCount: 3,
        angle: 60,
        spread: 55,
        origin: { x: 0, y: 0.7 },
      });
      confetti({
        particleCount: 3,
        angle: 120,
        spread: 55,
        origin: { x: 1, y: 0.7 },
      });

      if (Date.now() < end) {
        rafId = requestAnimationFrame(frame);
      }
    };

    frame();

    return () => {
      if (rafId !== undefined) cancelAnimationFrame(rafId);
    };
  }, [shouldFire]);
}
